import { AddRemoveSabreChangeLog, LogisticsChangeLogType, RouteRemovedLog } from '@/api/apis/route';
import { RouteLocationsListItem } from './RouteLocationsListItem';

type ChangeLogRouteLocationsListProps = {
  title?: string;
  logType: LogisticsChangeLogType;
  legs: RouteRemovedLog['legs'] | AddRemoveSabreChangeLog['legs'];
};

export const ChangeLogRouteLocationsList = ({ logType, legs, title }: ChangeLogRouteLocationsListProps) => (
  <div className="flex flex-col p-3 gap-3 rounded bg-base-90">
    {!!title && <span className="text-s-r text-base-20">{title}</span>}
    <div className="flex flex-col gap-1">
      {legs.map((leg) => (
        <RouteLocationsListItem key={leg.id} logType={logType} leg={leg} />
      ))}
    </div>
  </div>
);
